import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underconstruction',
  templateUrl: './underconstruction.component.html',
  styleUrls: ['./underconstruction.component.sass']
})
export class UnderconstructionComponent implements OnInit {

  year:any = 2023;

  constructor() { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

}
